// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"1866":"e37a0b60","9508":"36c7393a"}[chunkId] || chunkId) + "." + {"1294":"03e6c5b70bc93e39","1866":"02cec99460880506","7424":"72e587f11a50844b","8238":"0be3f541b6c09bcb","9508":"5a4293154aaff811"}[chunkId] + ".js";
};